<ng-container *transloco="let t; read: 'configuration'">
<drdp-container additionClasses="h-min">

    <div class="pl-5 pb-5 w-full">
        <h1 class=" text-2xl font-medium">{{ t('stateConfiguration.demographics.title') }}</h1>
        <form id="demographicForm" class="grid grid-cols-2 gap-1 pt-4" [formGroup]="demographicForm">
            <div class="col-span-1 items-center invisible lg:visible w-[100%]">
              <label class="font-bold" for="Name">{{ t('common.name') }}</label>
            </div>

            <div class="col-span-1 items-center invisible lg:visible w-[100%]">
              <label class="font-bold" for="Options">{{ t('stateConfiguration.demographics.options') }}</label>
            </div>

            <div class="col-span-2 lg:col-span-1 pt-5 items-center w-[100%]">
              <label class="font-normal" for="Statewide Student Identifier">{{ t('stateConfiguration.demographics.statewideStudentIdentifier') }}</label>
            </div>

            <div class="col-span-2 lg:col-span-1 pt-5 w-[100%]">
              <div class="grid col-span-1 sm:grid-cols-3 gap-3">
                <div class="col-span-1">
                  <mat-form-field id="ssidLabel" appearance="fill" class="bg-white">
                    <mat-label>{{ t('stateConfiguration.demographics.ssidLabel') }}</mat-label>
                    <input matInput
                           autocomplete="off"
                           id="SSID"
                           type="text"
                           [formControlName]="studentDemograpic.SSID"
                           maxlength="100">
                  </mat-form-field>
                </div>

                <div class="col-span-1">
                  <mat-form-field id="ssidAgency" class="bg-white">
                    <mat-label>{{ t('stateConfiguration.demographics.ssidMaxLength') }}</mat-label>
                    <input matInput
                           autocomplete="off"
                           id="customMaxLengthSSID"
                           type="number"
                           [formControlName]="studentDemograpic.maxLength">
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="col-span-2 lg:col-span-1 items-center w-[100%]">
              <label class="font-normal" for="Statewide Student Identifier">{{ t('stateConfiguration.demographics.agencyStudentIdentifier') }}</label>
            </div>

            <div class="col-span-2 lg:col-span-1 w-[100%]">
              <div class="grid col-span-1 sm:grid-cols-3 gap-4">
                <div class="col-span-1">
                  <mat-form-field id="adsiField" class="bg-white" appearance="fill">
                    <mat-label>{{ t('stateConfiguration.demographics.agencySidLabel') }}</mat-label>
                    <input matInput
                           autocomplete="off"
                           id="ADSI"
                           type="text"
                           [formControlName]="studentDemograpic.AgencySID"
                           maxlength="100">
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="flex flex-col justify-center w-[100%]">
              <label class="font-normal" for="Primary Disability">{{ t('stateConfiguration.demographics.regionLabel') }}</label>
            </div>

            <div class="flex flex-col w-[100%] lg:w-[35%] h-min">
              <mat-form-field id="fieldTypeAgency" floatLabel="always">
                <mat-select matNativeControl [placeholder]="t('stateConfiguration.demographics.selectLabel')" [formControlName]="studentDemograpic.RegionLabel" >
                  <mat-option [value]="regionTypeConst.Region">{{ t('stateConfiguration.demographics.region') }}</mat-option>
                  <mat-option [value]="regionTypeConst.SAU">{{ t('stateConfiguration.demographics.sau') }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flex flex-col justify-center w-[100%]">
              <label class="font-normal" for="Primary Disability">{{ t('stateConfiguration.demographics.primaryDisability') }}</label>
            </div>

            <div class="flex flex-col w-[100%] h-min">
                <mat-checkbox [formControlName]="studentDemograpic.PrimaryDisability"
                              color="primary">
                  {{ t('common.enable') }}
                </mat-checkbox>
            </div>

            <div class="flex flex-col justify-center w-[100%]">
              <label class="font-normal" for="Special Education Entry Date">{{ t('stateConfiguration.demographics.specialEdEntryDate') }}</label>
            </div>

            <div class="flex flex-col w-[100%] h-min">
                <mat-checkbox [formControlName]="studentDemograpic.SpecialEdEntryDate"
                               color="primary">
                  {{ t('common.enable') }}
                </mat-checkbox>
            </div>

            <div class="flex flex-col justify-center w-[100%]">
              <label class="font-normal" for="District of Liability">{{ t('stateConfiguration.demographics.districtOfLiability') }}</label>
            </div>

            <div class="flex flex-col w-[100%] h-min">
                <mat-checkbox [formControlName]="studentDemograpic.DistrictLiability"
                              color="primary">
                  {{ t('common.enable') }}
                </mat-checkbox>
            </div>

            <div class="flex flex-col justify-center w-[100%]">
              <label class="font-normal" for="Anticipated Date of Exit from Preschool Education to Kindergarten">{{ t('stateConfiguration.demographics.anticipatedDateExit') }}</label>
            </div>

            <div class="flex flex-col w-[100%] h-min">
                <mat-checkbox [formControlName]="studentDemograpic.AnticipatedDateExit"
                              color="primary">
                  {{ t('common.enable') }}
                </mat-checkbox>
            </div>

            <div class="flex flex-col justify-center w-[100%]">
              <label class="font-normal" for="Date of Exit from Preschool Special Education to Kindergarten">{{ t('stateConfiguration.demographics.dateExit') }}</label>
            </div>

            <div class="flex flex-col w-[100%] h-min">
                <mat-checkbox [formControlName]="studentDemograpic.DateExit"
                               color="primary">
                  {{ t('common.enable') }}
                </mat-checkbox>
            </div>

            <div class="flex flex-col justify-center w-[100%]">
              <label class="font-normal" for="Selpa">{{ t('stateConfiguration.demographics.selpa') }}</label>
            </div>

            <div class="flex flex-col w-[100%] h-min">
                <mat-checkbox [formControlName]="studentDemograpic.Selpa"
                               color="primary">
                  {{ t('common.enable') }}
                </mat-checkbox>
            </div>

            <div class="flex flex-col justify-center w-[100%]">
              <label class="font-normal" for="InitialAssessmentTool">{{ t('stateConfiguration.demographics.initialAssessmentTool') }}</label>
            </div>
            <div class="flex flex-col w-[100%] h-min">
                <mat-checkbox [formControlName]="studentDemograpic.initialAssessmentToolId"
                  color="primary">
                  {{ t('common.enable') }}
                </mat-checkbox>
            </div>

            <div class="flex flex-col justify-center w-[100%]">
              <label class="font-normal" for="Outcome 1">{{ t('stateConfiguration.demographics.outcome1') }}</label>
            </div>
            <div class="flex flex-col w-[100%] h-min">
                <mat-checkbox [formControlName]="studentDemograpic.outcome1Id"
                  color="primary">
                  {{ t('common.enable') }}
                </mat-checkbox>
            </div>

            <div class="flex flex-col justify-center w-[100%]">
              <label class="font-normal" for="Outcome 2">{{ t('stateConfiguration.demographics.outcome2') }}</label>
            </div>
            <div class="flex flex-col w-[100%] h-min">
                <mat-checkbox [formControlName]="studentDemograpic.outcome2Id"
                  color="primary">
                  {{ t('common.enable') }}
                </mat-checkbox>
            </div>

            <div class="flex flex-col justify-center w-[100%]">
              <label class="font-normal" for="Outcome 3">{{ t('stateConfiguration.demographics.outcome3') }}</label>
            </div>
            <div class="flex flex-col w-[100%] h-min">
                <mat-checkbox [formControlName]="studentDemograpic.outcome3Id"
                  color="primary">
                  {{ t('common.enable') }}
                </mat-checkbox>
            </div>

            <div class="col-span-2 w-[100%] h-min">
                <div class="flex justify-end w-[100%]">
                    <drdp-btn [color]="'cancel'" (click)="backToStatePage()">{{ t('common.cancel') }}</drdp-btn>
                    <span class=" ml-5"><drdp-btn (click)="onSubmit()">{{ t('common.saveAndSubmit') }}</drdp-btn></span>
                </div>
            </div>

          </form>
    </div>
</drdp-container>
</ng-container>
